import React, { useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { Spin } from "antd"
import { getWaiverSubmissionById, getWaiverSubmissionsByTripBooking } from "store/digital-waiver"
import { SignDocumentModal } from "pagesV2/pro/Embedded/BookingConfirmation/modal/SignDocument"
import { WaiverStatusModal } from "pagesV2/pro/DigitalWaiverAndContracts/SharedWaiver/components/WaiverStatusModal"
import { routes } from "router"

export default function WaiverResumePage() {
  const params = useParams()
  const { uuid, token } = params
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { data: submission, loading } = useSelector((state) => state.digitalWaiver.currentWaiverSubmission)

  useEffect(() => {
    dispatch(getWaiverSubmissionById(token)).then(() => {
      if (uuid) dispatch(getWaiverSubmissionsByTripBooking(uuid))
    })
  }, [token]) // eslint-disable-line

  useEffect(() => {
    if (submission?.status === "signed") {
      window.history.pushState(null, "", window.location.href)
      const handlePopState = () => window.history.pushState(null, "", window.location.href)
      window.addEventListener("popstate", handlePopState)
      return () => window.removeEventListener("popstate", handlePopState)
    }
  }, [submission?.status])

  if (loading || !submission) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Spin size="large" />
      </div>
    )
  }

  if (submission?.status === "signed") return <WaiverStatusModal type="signed" />
  if (submission?.status === "canceled") return <WaiverStatusModal type="canceled" />

  return (
    <SignDocumentModal
      uuid={uuid}
      waiverSubmissionId={token}
      pendingSubmission={submission?.pending_waiver_submissions || []}
      bookingWaivers={submission?.booking_waivers || []}
      open={true}
      fullScreen
      onCancel={() => navigate(routes.clientWaiverThankYou())}
      onDraftSaved={() => navigate(routes.clientWaiverThankYou(), { state: { isDraft: true } })}
    />
  )
}
